import { __assign, __extends, __makeTemplateObject, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { InputWithSuggestions, InputWithSuggestionsPropTypes, } from '../Input/InputWithSuggestions';
import { getValueOf, getLabelOf, findSuggestionByValue } from '../Input/util';
var SelectSearchableComponent = /** @class */ (function (_super) {
    __extends(SelectSearchableComponent, _super);
    function SelectSearchableComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.selectSearchableRef = React.createRef();
        /**
         * While the end-user types into the field, the
         * value inside the field may be invalid.
         */
        _this.handleOnChange = function (_event, _value, displayValue) {
            _this.setState({
                searchQuery: displayValue,
                enableFiltering: true,
            });
        };
        _this.handleOnSuggestionsShow = function () {
            var onSuggestionsShow = _this.props.onSuggestionsShow;
            _this.setState({
                enableFiltering: false,
            });
            if (onSuggestionsShow) {
                onSuggestionsShow();
            }
        };
        _this.handleOnSelectionChange = function (e, newValue) {
            var onChange = _this.props.onChange;
            _this.setState({
                lastValidValue: newValue,
            });
            onChange(e, newValue);
        };
        _this.handleOnOutsideClick = function (e) {
            var _a = _this.props, value = _a.value, children = _a.children, onOutsideClick = _a.onOutsideClick;
            var suggestion = findSuggestionByValue(children, value);
            if (suggestion) {
                _this.setState({ lastValidValue: getValueOf(suggestion) });
            }
            if (onOutsideClick) {
                onOutsideClick(e);
            }
        };
        _this.clearSelection = function (e) {
            var lastValidValue = _this.state.lastValidValue;
            var onChange = _this.props.onChange;
            if (lastValidValue === '')
                return;
            _this.setState({ lastValidValue: '' });
            onChange(e, '');
        };
        _this.generateSearchMatchFunction = function () {
            var searchMatch = _this.props.searchMatch;
            var enableFiltering = _this.state.enableFiltering;
            if (!enableFiltering)
                return function () { return true; };
            if (searchMatch)
                return searchMatch;
            return undefined;
        };
        _this.handleInputKeyDown = function (e) {
            var key = e.key;
            var _a = _this.props, isClearable = _a.isClearable, value = _a.value, onKeyDown = _a.onKeyDown;
            var _b = _this.state, lastValidValue = _b.lastValidValue, searchQuery = _b.searchQuery;
            var ignoreKey = e.ctrlKey ||
                e.metaKey ||
                e.altKey ||
                key === 'ArrowLeft' ||
                key === 'ArrowRight' ||
                key === 'Shift';
            if (ignoreKey)
                return;
            switch (key) {
                case 'Backspace':
                    if (!isClearable && searchQuery.length <= 2)
                        break;
                    if (isClearable && !searchQuery) {
                        _this.clearSelection(e);
                    }
                    break;
                case 'Tab':
                    if (isClearable && !lastValidValue) {
                        _this.clearSelection(e);
                    }
                    else if (value !== lastValidValue) {
                        _this.setState({
                            lastValidValue: value,
                        });
                    }
                    break;
                default:
            }
            if (onKeyDown)
                onKeyDown(e);
        };
        _this.state = {
            searchQuery: '',
            lastValidValue: props.value,
            enableFiltering: false,
        };
        return _this;
    }
    // props and state are any because of type inference problems in styled()
    SelectSearchableComponent.getDerivedStateFromProps = function (props, state) {
        return __assign(__assign({}, state), { lastValidValue: props.value });
    };
    SelectSearchableComponent.prototype.componentDidMount = function () {
        var _a = this.props, value = _a.value, children = _a.children;
        var suggestion = findSuggestionByValue(children, value);
        if (suggestion)
            this.setState({ searchQuery: getLabelOf(suggestion) });
    };
    SelectSearchableComponent.prototype.render = function () {
        var _a = this.props, children = _a.children, onChange = _a.onChange, value = _a.value, _b = _a.shouldShowOptionsWhenEmpty, shouldShowOptionsWhenEmpty = _b === void 0 ? true : _b, props = __rest(_a, ["children", "onChange", "value", "shouldShowOptionsWhenEmpty"]);
        var lastValidValue = this.state.lastValidValue;
        return (React.createElement(InputWithSuggestions, __assign({}, props, { ref: this.selectSearchableRef, searchMatch: this.generateSearchMatchFunction(), value: lastValidValue, onChange: this.handleOnChange, onKeyDown: this.handleInputKeyDown, onSelectionChange: this.handleOnSelectionChange, onSuggestionsShow: this.handleOnSuggestionsShow, onOutsideClick: this.handleOnOutsideClick, shouldShowOptionsWhenEmpty: shouldShowOptionsWhenEmpty, shouldShowChevron: true, shouldFocusFirstEntry: true }), children));
    };
    return SelectSearchableComponent;
}(React.Component));
export { SelectSearchableComponent };
export var SelectSearchable = styled(function (_a) {
    var props = __rest(_a, []);
    return React.createElement(SelectSearchableComponent, __assign({}, props));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
SelectSearchable.propTypes = __assign(__assign({}, InputWithSuggestionsPropTypes), { isClearable: PropTypes.bool });
var templateObject_1;
//# sourceMappingURL=SelectSearchable.js.map